module.exports = {"pathContext":{"slug":"/it/lowdamage/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-lowdamage.json
// module id = 1589
// module chunks = 206320826777666